import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import MantineGlobalLayout from "./components/layout/MantineGlobalLayout";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MantineGlobalLayout>
      <App />
    </MantineGlobalLayout>
  </React.StrictMode>
);
